import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../../LinkProvider";
import AnimatedCTA from "../AnimatedCTA";

function MarketsCTA() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt mb-[80px] xl:mb-[160px] relative z-50">
      <div className="glcontainer flex flex-col items-center gap-[40px] text-center">
        <div className="flex flex-col gap-[20px] items-center max-w-[808px] mx-auto">
          <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none">
            {t("markets.cta.title")}
          </h2>
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4] max-w-[643px]">
            {t("markets.cta.desc")}
          </p>
        </div>
        <AnimatedCTA href={link} mobile>{t("btn.start-trading")}</AnimatedCTA>
      </div>
    </section>
  );
}

export default MarketsCTA;
